import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import { Modal } from 'components/common';
import PropType from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Form, Formik } from 'formik';
import { CustomInput } from 'components/formik';
import * as Yup from 'yup';

const EditPlanModal = ({ onEditPlan, plan, modal }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const onSubmitForm = async (form) => {
    if (loading) return;
    setLoading(true);
    await onEditPlan(form);
    setLoading(false);
  };

  const initFormikValues = {
    months: plan?.months || 0,
    limitProducts: plan?.limitProducts || 0,
    limitPhotos: plan?.limitPhotos || 0,
    priceEur: plan?.priceEur || 0,
    priceChf: plan?.priceChf || 0
  };
  const FormSchema = Yup.object().shape({
    months: Yup.number()
      .positive(t('genericNumericFieldError1'))
      .integer(t('genericNumericFieldError2'))
      .required(t('genericNumericFieldError3'))
      .max(5000, t('genericNumericFieldError4')),
    limitProducts: Yup.number()
      .positive(t('genericNumericFieldError1'))
      .integer(t('genericNumericFieldError2'))
      .required(t('genericNumericFieldError3'))
      .max(5000, t('genericNumericFieldError4')),
    limitPhotos: Yup.number()
      .positive(t('genericNumericFieldError1'))
      .integer(t('genericNumericFieldError2'))
      .required(t('genericNumericFieldError3'))
      .max(5000, t('genericNumericFieldError4')),
    priceEur: Yup.number()
      .positive(t('genericNumericFieldError1'))
      .integer(t('genericNumericFieldError2'))
      .required(t('genericNumericFieldError3'))
      .max(5000, t('genericNumericFieldError4')),
    priceChf: Yup.number()
      .positive(t('genericNumericFieldError1'))
      .integer(t('genericNumericFieldError2'))
      .required(t('genericNumericFieldError3'))
      .max(5000, t('genericNumericFieldError4'))
  });

  return (
    <Modal isOpen={modal.isOpenModal} onRequestClose={modal.onCloseModal}>
      <Formik
        initialValues={initFormikValues}
        validateOnChange
        validationSchema={FormSchema}
        onSubmit={onSubmitForm}
      >
        {() => (
          <Form>
            <div className="product-form" style={{ display: 'block' }}>
              <h2>{plan.name}</h2>
              <div className="product-form-field">
                <Field
                  name="months"
                  id="months"
                  type="number"
                  label={`* ${t('planTableDuration')} (${t(
                    'planTableMonths'
                  )})`}
                  component={CustomInput}
                />
              </div>
              <div className="product-form-field">
                <Field
                  name="limitProducts"
                  id="limitProducts"
                  type="number"
                  label={`* ${t('planTableProductsLimit')}`}
                  component={CustomInput}
                />
              </div>
              <div className="product-form-field">
                <Field
                  name="limitPhotos"
                  id="limitPhotos"
                  type="number"
                  label={`* ${t('planTablePhotosLimit')}`}
                  component={CustomInput}
                />
              </div>
              <div className="product-form-field">
                <Field
                  name="priceEur"
                  id="priceEur"
                  type="number"
                  label={`* ${t('planTablePrice')} (€)`}
                  component={CustomInput}
                />
              </div>
              <div className="product-form-field">
                <Field
                  name="priceChf"
                  id="priceChf"
                  type="number"
                  label={`* ${t('planTablePrice')} (CHF)`}
                  component={CustomInput}
                />
              </div>
            </div>
            <div className="product-form-submit">
              <br />
              <br />
              <button className="button w-100-mobile" type="submit">
                {loading ? <LoadingOutlined /> : <CheckOutlined />}
                &nbsp;
                {loading ? t('loadingMessage') : t('genericFormSaveButton')}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

EditPlanModal.propTypes = {
  onEditPlan: PropType.func.isRequired,
  plan: PropType.shape({
    name: PropType.string,
    months: PropType.number,
    limitProducts: PropType.number,
    limitPhotos: PropType.number,
    priceEur: PropType.number,
    priceChf: PropType.number
  }).isRequired,
  modal: PropType.shape({
    onCloseModal: PropType.func,
    isOpenModal: PropType.bool
  }).isRequired
};

export default EditPlanModal;
